import { GraphQLClient } from 'graphql-request';
import { RequestInit } from 'graphql-request/dist/types.dom';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };

function fetcher<TData, TVariables extends { [key: string]: any }>(client: GraphQLClient, query: string, variables?: TVariables, requestHeaders?: RequestInit['headers']) {
  return async (): Promise<TData> => client.request({
    document: query,
    variables,
    requestHeaders
  });
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  CertificateAwardID: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  DatetimeUTC: { input: string; output: string; }
  JSON: { input: Record<string, unknown>; output: Record<string, unknown>; }
  StrInt: { input: any; output: any; }
  UUID: { input: string; output: string; }
  Upload: { input: File; output: File; }
  UserID: { input: string; output: string; }
  ValetReceipt: { input: string; output: string; }
};

export type AnyContent = GenericContent | ProfileContent | StandaloneChallengeContent;

export type AnyContentPaginationWindow = {
  __typename?: 'AnyContentPaginationWindow';
  items: Array<AnyContent>;
  totalItems: Scalars['Int']['output'];
};

export type AuthorName = {
  __typename?: 'AuthorName';
  name: Scalars['String']['output'];
};

export type AuthorNameProfile = AuthorName | Profile;

export type AwardedBadge = {
  __typename?: 'AwardedBadge';
  /** When this badge was awarded to the profile. */
  awardedAt: Scalars['DatetimeUTC']['output'];
  /** The definition of the badge. */
  definition: BadgeDefinition;
  /** The profile the badge was awarded to. */
  profile: Profile;
};

export type AwardedBadgePaginationWindow = {
  __typename?: 'AwardedBadgePaginationWindow';
  items: Array<AwardedBadge>;
  totalItems: Scalars['Int']['output'];
};

export type AwardedCertificate = {
  __typename?: 'AwardedCertificate';
  /** When this award was accepted by the user. */
  acceptedAt: Scalars['DatetimeUTC']['output'];
  /** When this award was issued to the user. */
  awardedAt: Scalars['DatetimeUTC']['output'];
  /** The certificate definition that was granted by this award. */
  definition: CertificateDefinition;
  /** Unique ID for this certificate award. */
  id: Scalars['CertificateAwardID']['output'];
  /** URL to certificate image. */
  imageUrl: Scalars['String']['output'];
  /** Return a URL to share a certificate to a LinkedIn profile. */
  linkedinShareUrl: Scalars['String']['output'];
  /** Return a URL to the OpenBadge credential for a certificate. */
  obCredentialUrl: Scalars['String']['output'];
  /**
   * Whether or not this certificate is visible on the user's
   * public profile.
   */
  public: Scalars['Boolean']['output'];
  /**
   * Return a 'permalink' URL to the public profile modal for
   * an accepted certificate. The URL will remain valid even
   * if the user changes their handle.
   *
   * Will be null if the certificate award is not public.
   */
  publicSharePermalink?: Maybe<Scalars['String']['output']>;
};

export type AwardedCertificateBase = {
  __typename?: 'AwardedCertificateBase';
  /** When this award was accepted by the user. */
  acceptedAt: Scalars['DatetimeUTC']['output'];
  /** When this award was issued to the user. */
  awardedAt: Scalars['DatetimeUTC']['output'];
  /** The certificate definition that was granted by this award. */
  definition: CertificateDefinition;
  /** Unique ID for this certificate award. */
  id: Scalars['CertificateAwardID']['output'];
  /** URL to certificate image. */
  imageUrl: Scalars['String']['output'];
  /**
   * Whether or not this certificate is visible on the user's
   * public profile.
   */
  public: Scalars['Boolean']['output'];
};

export type AwardedCertificateBasePaginationWindow = {
  __typename?: 'AwardedCertificateBasePaginationWindow';
  items: Array<AwardedCertificateBase>;
  totalItems: Scalars['Int']['output'];
};

export type AwardedCertificatePayloadResponse = {
  __typename?: 'AwardedCertificatePayloadResponse';
  payload?: Maybe<AwardedCertificate>;
  userError?: Maybe<UserErrorSchema>;
};

export type BadgeDefinition = {
  __typename?: 'BadgeDefinition';
  /** The description of the badge. */
  description: Scalars['String']['output'];
  /** The image URL of the badge. */
  imageUrl: Scalars['String']['output'];
  /** The unique identifier of the badge. */
  slug: Scalars['String']['output'];
  /** The title of the badge. */
  title: Scalars['String']['output'];
};

export type BaseTableOfContentsEntry = {
  __typename?: 'BaseTableOfContentsEntry';
  href: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type BlogPost = {
  __typename?: 'BlogPost';
  /** Authors of the blog post. */
  authors: Array<AuthorNameProfile>;
  /** HTML + markdown body of the blog post. */
  body: Scalars['String']['output'];
  /** Category of the blog post. */
  category: Scalars['String']['output'];
  /** Description of the blog post. */
  description: Scalars['String']['output'];
  /** Features of the blog post. */
  features: Array<BlogPostFeature>;
  /** Most recent date of modification of the blog post. */
  modifiedAt: Scalars['DatetimeUTC']['output'];
  /** Initial publication date of the blog post. */
  publishedAt: Scalars['DatetimeUTC']['output'];
  /** Series that the blog post belongs to. */
  series?: Maybe<BlogPostSeries>;
  /** Index of the blog post in its series. */
  seriesIndex?: Maybe<Scalars['Int']['output']>;
  /** Slug of the blog post. */
  slug: Scalars['String']['output'];
  /** URL to the thumbnail of the blog post. */
  thumbnail?: Maybe<Scalars['String']['output']>;
  /** Title of the blog post. */
  title: Scalars['String']['output'];
};

export type BlogPostFeature = {
  __typename?: 'BlogPostFeature';
  /** Description of the feature. */
  description: Scalars['String']['output'];
  /** URL fragment that links to this feature in the post. */
  fragment: Scalars['String']['output'];
  /** URL to the thumbnail of the feature. */
  thumbnail: Scalars['String']['output'];
};

export type BlogPostSeries = {
  __typename?: 'BlogPostSeries';
  /** Blog posts in the series. */
  posts: Array<BlogPost>;
  /** Title of the blog post series. */
  title: Scalars['String']['output'];
};

export type CategorySchema = {
  __typename?: 'CategorySchema';
  /** URL to the card icon of the category. */
  cardIconUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Returns an event challenge in this category with the given challenge ID.
   *
   * Raises:
   *     ObjectNotFoundError if the event challenge does not exist
   */
  eventChallenge: EventChallengeSchema;
  /** Returns the event challenges in the category, sorted by ascending challenge id. */
  eventChallenges: Array<EventChallengeSchema>;
  /** ID of the category. */
  id: Scalars['UUID']['output'];
  /**
   * A Category is locked iff:
   *     unlocked_at is not null
   *     unlocked_at is in the future
   */
  isLocked: Scalars['Boolean']['output'];
  /** Number of challenges in the category. */
  numChallenges: Scalars['Int']['output'];
  /** Slug of the category. */
  slug: Scalars['String']['output'];
  /** Title of the category. */
  title: Scalars['String']['output'];
  /** Total number of points in the category. */
  totalPoints: Scalars['Int']['output'];
  /** Timestamp for when the category becomes unlocked. Null implies unlocked. */
  unlockAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CategorySchemaEventChallengeArgs = {
  challengeId: Scalars['UUID']['input'];
};

export type CertificateDefinition = {
  __typename?: 'CertificateDefinition';
  /** Description of the certificate. */
  description: Scalars['String']['output'];
  /** A general image for the certificate. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Unique, short identifier for the certificate definition. */
  slug: Scalars['String']['output'];
  /** Title of the certificate, e.g 'Quantum Algorithms'. */
  title: Scalars['String']['output'];
};

export type CertificateRecipientInfo = {
  __typename?: 'CertificateRecipientInfo';
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
};

export type ChallengeSchema = {
  __typename?: 'ChallengeSchema';
  /**
   * Returns the code blocks associated with this challenge.
   *
   * Args:
   *     withImports: whether to return an additional code block for imports
   *     withTests: whether to return additional code blocks for public tests
   *
   * .. notes::
   *
   *     Additional code blocks for public tests include:
   *
   *         * ``TEST_CASES``: rendered public test cases
   *         * ``TEST_SUPPORT``: public test case runner
   *
   *     All additional code blocks have ``expanded=True`` by default.
   */
  codeBlocks: Array<CodeBlockSchema>;
  /** Description of the challenge. */
  description: Scalars['String']['output'];
  /** URL to the PennyLane discussion forum page dedicated to the challenge. */
  discussionForumUrl?: Maybe<Scalars['String']['output']>;
  /** Whether the challenge has any private test cases. */
  hasPrivateTestCases: Scalars['Boolean']['output'];
  /** UUID of the challenge. */
  id: Scalars['UUID']['output'];
  /** Slug of the challenge. */
  slug: Scalars['String']['output'];
  /** Summary of the challenge. */
  summary: Scalars['String']['output'];
  /** Returns the public test cases associated with this challenge. */
  testCases: Array<TestCaseSchema>;
  /** Title of the challenge. */
  title: Scalars['String']['output'];
  /** Version of the challenge. */
  version: Scalars['Int']['output'];
};


export type ChallengeSchemaCodeBlocksArgs = {
  withImports?: Scalars['Boolean']['input'];
  withTests?: Scalars['Boolean']['input'];
};

export type ChatCreateInput = {
  challengeId?: InputMaybe<Scalars['UUID']['input']>;
  message: MessageInput;
  scope: ChatScope;
  subject: Scalars['String']['input'];
  submissionId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ChatFilterInput = {
  byChallenge?: InputMaybe<Scalars['UUID']['input']>;
  byLocked?: InputMaybe<Scalars['Boolean']['input']>;
  byModerator?: InputMaybe<ChatModeratorFilterInput>;
  byParticipant?: InputMaybe<Scalars['UUID']['input']>;
  byScope?: InputMaybe<ChatScope>;
  byStatus?: InputMaybe<Array<ChatStatus>>;
  bySubject?: InputMaybe<Scalars['String']['input']>;
  byTeam?: InputMaybe<Scalars['UUID']['input']>;
};

export type ChatFilterOptionsSchema = {
  __typename?: 'ChatFilterOptionsSchema';
  /** Unique assignees of all available chats in the support system. */
  assignee: PlayerSchemaPaginationWindow;
  /**
   * ``True`` if there is at least one chat in the event that does not have a
   * moderator assigned.
   */
  hasUnassignedChat: Scalars['Boolean']['output'];
  /** Unique participantss of all chats in the support system. */
  participant: PlayerSchemaPaginationWindow;
  /** Unique statuses of all available chats in the support system. */
  status: Array<ChatStatus>;
  /** Unique subjects of all available chats in the support system. */
  subject: StrPaginationWindow;
  /** Unique teams of all available chats in the support system. */
  team: TeamSchemaPaginationWindow;
};


export type ChatFilterOptionsSchemaAssigneeArgs = {
  page?: InputMaybe<PageInput>;
};


export type ChatFilterOptionsSchemaParticipantArgs = {
  page?: InputMaybe<PageInput>;
};


export type ChatFilterOptionsSchemaSubjectArgs = {
  page?: InputMaybe<PageInput>;
};


export type ChatFilterOptionsSchemaTeamArgs = {
  page?: InputMaybe<PageInput>;
};

export type ChatModeratorFilterInput = {
  moderatorId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ChatResponse = {
  __typename?: 'ChatResponse';
  chat?: Maybe<ChatSchema>;
  userError?: Maybe<UserErrorSchema>;
};

export type ChatSchema = {
  __typename?: 'ChatSchema';
  /** Challenge of the chat. */
  challenge?: Maybe<ChallengeSchema>;
  /** ID of the chat. */
  id: Scalars['UUID']['output'];
  /** Locked state of the chat. */
  locked: Scalars['Boolean']['output'];
  /** Messages in the chat. */
  messages: MessageSchemaPaginationWindow;
  /** Moderator assigned to the chat. */
  moderator?: Maybe<PlayerSchema>;
  /** Number of messages in the chat. */
  numMessages: Scalars['Int']['output'];
  /** Players who have appended a message to the chat. */
  participants: Array<PlayerSchema>;
  /** Scope of the chat. */
  scope: ChatScope;
  /** Status of the chat. */
  status: ChatStatus;
  /** Subject of the chat. */
  subject: Scalars['String']['output'];
  /** Submission of the chat. */
  submission?: Maybe<SubmissionSchema>;
  /** Timestamp when this chat was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};


export type ChatSchemaMessagesArgs = {
  page?: InputMaybe<PageInput>;
};

export type ChatSchemaPaginationWindow = {
  __typename?: 'ChatSchemaPaginationWindow';
  items: Array<ChatSchema>;
  totalItems: Scalars['Int']['output'];
};

export enum ChatScope {
  Player = 'PLAYER',
  Team = 'TEAM'
}

export enum ChatStatus {
  Resolved = 'RESOLVED',
  WaitingOnModerator = 'WAITING_ON_MODERATOR',
  WaitingOnRequestor = 'WAITING_ON_REQUESTOR'
}

export type CodeBlockSchema = {
  __typename?: 'CodeBlockSchema';
  code: Scalars['String']['output'];
  expanded: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['UUID']['output']>;
  indent: Scalars['Int']['output'];
  type: CodeBlockType;
};

export enum CodeBlockType {
  SolutionAnswer = 'SOLUTION_ANSWER',
  SolutionContext = 'SOLUTION_CONTEXT',
  SolutionTemplate = 'SOLUTION_TEMPLATE',
  TestCases = 'TEST_CASES',
  TestSupport = 'TEST_SUPPORT'
}

export enum CodebookCompletionStatus {
  Attempted = 'attempted',
  Completed = 'completed',
  Unattempted = 'unattempted'
}

export type CodebookExercise = {
  __typename?: 'CodebookExercise';
  /** Code template of the Codebook exercise. */
  codeTemplate: Scalars['String']['output'];
  /** Content of the Codebook exercise. */
  content: Scalars['String']['output'];
  /**
   * Latest passed submission by the caller.
   *
   * None if:
   * * unauthenticated
   * * no submissions have passed.
   */
  latestPassedSubmission?: Maybe<CodebookSubmission>;
  /**
   * Latest submission by the caller.
   *
   * None if:
   * * unauthenticated
   * * no submission has been made.
   */
  latestSubmission?: Maybe<CodebookSubmission>;
  /** Slug of a related theory in the same topic as the exercise. */
  relatedTheorySlug?: Maybe<Scalars['String']['output']>;
  /** Slug of the Codebook exercise. */
  slug: Scalars['String']['output'];
  /**
   * Official solution of exercise
   *
   * None if:
   * * unauthenticated
   * * no submissions have passed
   */
  solution?: Maybe<Scalars['String']['output']>;
  /** Caller's completion status for the exercise. */
  status: CodebookCompletionStatus;
  /** Title of the Codebook exercise. */
  title: Scalars['String']['output'];
};

export type CodebookModule = {
  __typename?: 'CodebookModule';
  /** Banner image URL of the Codebook module. */
  bannerImageUrl: Scalars['String']['output'];
  /** Category of the Codebook module. */
  category: Scalars['String']['output'];
  /** Description of the Codebook module. */
  description: Scalars['String']['output'];
  /** Whether the Codebook module is featured. */
  featured: Scalars['Boolean']['output'];
  /** Label of the Codebook module. */
  label: Scalars['String']['output'];
  /** Locales of the Codebook module. */
  locales: Array<Scalars['String']['output']>;
  /** Number of topics contained in the module. */
  numTopics: Scalars['Int']['output'];
  /** Number of topics the caller has attempted in the module. */
  numTopicsAttempted?: Maybe<Scalars['Int']['output']>;
  /** Number of topics the caller has completed in the module. */
  numTopicsCompleted?: Maybe<Scalars['Int']['output']>;
  /** Paths that contain the module. */
  paths: Array<CodebookPath>;
  /** Position of the Codebook module on the Main Map. */
  position: CodebookModulePosition;
  /** Prerequisite modules for this module. */
  prerequisites: Array<CodebookModule>;
  /** Slug of the Codebook module. */
  slug: Scalars['String']['output'];
  /** Caller's progress for the module. */
  status: CodebookCompletionStatus;
  /** Title of the Codebook module. */
  title: Scalars['String']['output'];
  /** Get one topic contained in the module by slug. */
  topic?: Maybe<CodebookTopic>;
  /** All topics contained in the module. */
  topics: Array<CodebookTopic>;
};


export type CodebookModuleTopicArgs = {
  slug: Scalars['String']['input'];
};

export type CodebookModulePosition = {
  __typename?: 'CodebookModulePosition';
  /** X-coordinate of the Codebook module. */
  x: Scalars['Int']['output'];
  /** Y-coordinate of the Codebook module. */
  y: Scalars['Int']['output'];
};

export type CodebookPath = {
  __typename?: 'CodebookPath';
  /** Description of the Codebook path. */
  description: Scalars['String']['output'];
  /** Whether the Codebook path is featured. */
  featured: Scalars['Boolean']['output'];
  /** Members of the Codebook path. */
  members: Array<CodebookPathMember>;
  /** Number of modules contained in the path. */
  numModules: Scalars['Int']['output'];
  /** Number of modules the caller has attempted in the path. */
  numModulesAttempted?: Maybe<Scalars['Int']['output']>;
  /** Number of modules the caller has completed in the path. */
  numModulesCompleted?: Maybe<Scalars['Int']['output']>;
  /** Slug of the Codebook path. */
  slug: Scalars['String']['output'];
  /** Caller's progress for the Codebook path. */
  status: CodebookCompletionStatus;
  /** Title of the Codebook path. */
  title: Scalars['String']['output'];
};

export type CodebookPathMember = {
  __typename?: 'CodebookPathMember';
  /** Module of the Codebook path member. */
  module: CodebookModule;
  /** Position of the Codebook path member. */
  position: CodebookModulePosition;
};

export type CodebookSubmission = {
  __typename?: 'CodebookSubmission';
  /** Code of the Codebook submission. */
  code: Scalars['String']['output'];
  /** ID of the Codebook submission. */
  id: Scalars['UUID']['output'];
  /** Result of the Codebook submission. */
  result?: Maybe<CodebookSubmissionResult>;
};

export type CodebookSubmissionModel = {
  code: Scalars['String']['input'];
  exercise: Scalars['String']['input'];
  module: Scalars['String']['input'];
  topic: Scalars['String']['input'];
};

export type CodebookSubmissionResult = {
  __typename?: 'CodebookSubmissionResult';
  /** Additional data of the Codebook submission result. */
  data?: Maybe<Scalars['JSON']['output']>;
  /** Message of the Codebook submission result. */
  message?: Maybe<Scalars['String']['output']>;
  /** Whether the Codebook submission result was successful. */
  success: Scalars['Boolean']['output'];
  /** User output of the Codebook submission result. */
  userOutput: Scalars['String']['output'];
};

export type CodebookTheory = {
  __typename?: 'CodebookTheory';
  /** Content of the Codebook theory. */
  content: Scalars['String']['output'];
  /** Slug of the Codebook theory. */
  slug: Scalars['String']['output'];
  /** Title of the Codebook theory. */
  title: Scalars['String']['output'];
};

export type CodebookTopic = {
  __typename?: 'CodebookTopic';
  /** URL to the PennyLane discussion forum page dedicated to the topic. */
  discussionForumUrl?: Maybe<Scalars['String']['output']>;
  /** Get one exercise contained in the topic by slug. */
  exercise?: Maybe<CodebookExercise>;
  /** All exercises contained in the topic. */
  exercises: Array<CodebookExercise>;
  /** Learnings of the topic. */
  learnings: Scalars['String']['output'];
  /** Module which contains this topic. */
  module: CodebookModule;
  /** Slug of the topic. */
  slug: Scalars['String']['output'];
  /** Caller's completion status for the topic. */
  status: CodebookCompletionStatus;
  /** Summary of the topic. */
  summary: Scalars['String']['output'];
  /** All theories contained in the topic. */
  theories: Array<CodebookTheory>;
  /** Get one theory contained in the topic by slug. */
  theory?: Maybe<CodebookTheory>;
  /** Thumbnail of the topic. */
  thumbnail: Scalars['String']['output'];
  /** Title of the topic. */
  title: Scalars['String']['output'];
};


export type CodebookTopicExerciseArgs = {
  slug: Scalars['String']['input'];
};


export type CodebookTopicTheoryArgs = {
  slug: Scalars['String']['input'];
};

export type Compilation = {
  __typename?: 'Compilation';
  /** Paragraph summary of the compilation. */
  abstract: Scalars['String']['output'];
  /** Names of the authors of the compilation. */
  authorNames: Array<Scalars['String']['output']>;
  /** Authors of this compilation. */
  authors: Array<Profile>;
  /** Category of the compilation. */
  category: Scalars['String']['output'];
  /** Citation of the compilation. */
  citation: Scalars['String']['output'];
  /** URL to the hero of the compilation. */
  heroImage?: Maybe<Scalars['String']['output']>;
  /** Long description of the compilation. */
  longDescription: Scalars['String']['output'];
  /** Most recent date of modification of the compilation. */
  modifiedAt: Scalars['DatetimeUTC']['output'];
  /** Papers associated with this compilation. */
  papers: Array<CompilationPaper>;
  /** Initial publication date of the compilation. */
  publishedAt: Scalars['DatetimeUTC']['output'];
  /** Resources associated with this compilation. */
  resources: Array<CompilationResource>;
  /** Short description of the compilation. */
  shortDescription: Scalars['String']['output'];
  /** Slug of the compilation. */
  slug: Scalars['String']['output'];
  /** Tabs associated with this compilation. */
  tabs: Array<CompilationTab>;
  /** URL to the thumbnail of the compilation. */
  thumbnailImage?: Maybe<Scalars['String']['output']>;
  /** Title of the compilation. */
  title: Scalars['String']['output'];
};

export type CompilationPaper = {
  __typename?: 'CompilationPaper';
  /** Short description of this paper. */
  description: Scalars['String']['output'];
  /** Link text for the secondary post related to this paper. */
  secondaryCtaText?: Maybe<Scalars['String']['output']>;
  /** URL to a secondary post related to this paper. */
  secondaryCtaUrl?: Maybe<Scalars['String']['output']>;
  /** URL of this paper. */
  url: Scalars['String']['output'];
};

export type CompilationResource = {
  __typename?: 'CompilationResource';
  /** Optional URL to the thumbnail of this resource. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Title of this resource. */
  title: Scalars['String']['output'];
  /** Type of this resource. */
  type: CompilationResourceType;
  /** URL of this resource. */
  url: Scalars['String']['output'];
};

export enum CompilationResourceType {
  Blog = 'BLOG',
  Demo = 'DEMO',
  Doc = 'DOC',
  Glossary = 'GLOSSARY',
  Tool = 'TOOL'
}

export type CompilationTab = {
  __typename?: 'CompilationTab';
  /** Markdown + HTML body of this tab. */
  content: Scalars['String']['output'];
  /** Unique identifier of this tab. */
  slug: Scalars['String']['output'];
  /** Title of this tab. */
  title: Scalars['String']['output'];
};

export type Content = {
  /** Authors of the content. */
  authors: Array<AuthorNameProfile>;
  /** Categories of the content. */
  categories?: Maybe<Array<Scalars['String']['output']>>;
  /** Brief description of the content. */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique ID for the content. */
  id: Scalars['String']['output'];
  /** Fully-qualified URL to the content. */
  link: Scalars['String']['output'];
  /** Datetime when the content was last modified. */
  modifiedAt: Scalars['DatetimeUTC']['output'];
  /** Datetime when the content was first published. */
  publishedAt: Scalars['DatetimeUTC']['output'];
  /**
   * Content related to the content.
   *
   * Args:
   *     count: Maximum number of items to return.
   *     contentTypes: A list of content types to filter by. If ``None``, no
   *       filtering will be performed.
   */
  related: Array<Content>;
  /** Slug of the content. Unique by ``type``. */
  slug: Scalars['String']['output'];
  /** Thumbnail URL of the content. */
  thumbnail?: Maybe<Scalars['String']['output']>;
  /** Title of the content. */
  title: Scalars['String']['output'];
  /** Type of the content. */
  type: ContentType;
};


export type ContentRelatedArgs = {
  contentTypes?: InputMaybe<Array<ContentType>>;
  count: Scalars['Int']['input'];
};

export type ContentSlugAndTypeInput = {
  slug: Scalars['String']['input'];
  type: ContentType;
};

export enum ContentType {
  Blog = 'BLOG',
  Challenge = 'CHALLENGE',
  CodebookTopic = 'CODEBOOK_TOPIC',
  Compilation = 'COMPILATION',
  DatasetFamily = 'DATASET_FAMILY',
  Demo = 'DEMO',
  Doc = 'DOC',
  Profile = 'PROFILE',
  Webpage = 'WEBPAGE'
}

export type Dataset = {
  __typename?: 'Dataset';
  /** Class of this dataset. */
  class: DatasetClass;
  /** Download URL of this dataset. */
  downloadUrl: Scalars['String']['output'];
  /** ID of this dataset. */
  id: Scalars['String']['output'];
  /** Parameter values of this dataset. */
  parameterValues: Array<DatasetParameterValue>;
};

export type DatasetAttribute = {
  __typename?: 'DatasetAttribute';
  /** Name of this dataset attribute. */
  name: Scalars['String']['output'];
  /** Python type of this dataset attribute. */
  pythonType: Scalars['String']['output'];
};

export type DatasetClass = {
  __typename?: 'DatasetClass';
  /** Attributes of this dataset class. */
  attributes: Array<DatasetAttribute>;
  /** Datasets in this dataset class that match the given parameter selection. */
  datasets: Array<Dataset>;
  /** Dataset families of this dataset class. */
  families: Array<DatasetFamily>;
  /** ID of this dataset class. */
  id: Scalars['String']['output'];
  /** Get available parameter options for a given parameter selection. */
  parameterOptions: DatasetParameterOptions;
  /** JSON document representing a tree of the available dataset parameters. */
  parameterTree: Scalars['JSON']['output'];
  /** Parameters of this dataset class. */
  parameters: Array<DatasetParameter>;
  /** Title of this dataset class. */
  title: Scalars['String']['output'];
};


export type DatasetClassDatasetsArgs = {
  parameters?: InputMaybe<Array<DatasetParameterInput>>;
};


export type DatasetClassParameterOptionsArgs = {
  currentSelection?: InputMaybe<Scalars['JSON']['input']>;
};

export type DatasetCollection = {
  __typename?: 'DatasetCollection';
  /** About this dataset collection. */
  about: Scalars['String']['output'];
  /** Dataset families in this dataset collection. */
  families: Array<DatasetFamily>;
  /** URL to the hero image of this dataset collection. */
  heroImage?: Maybe<Scalars['String']['output']>;
  /** Number of dataset families in this dataset collection. */
  numFamilies: Scalars['Int']['output'];
  /** URL to the preview image of this dataset collection. */
  previewImage: Scalars['String']['output'];
  /** Slug of this dataset collection. */
  slug: Scalars['String']['output'];
  /** Tags of the families in this dataset collection. */
  tags: Array<Scalars['String']['output']>;
  /** Title of this dataset collection. */
  title: Scalars['String']['output'];
};

export type DatasetCollectionDatasetFamily = DatasetCollection | DatasetFamily;

export type DatasetFamily = {
  __typename?: 'DatasetFamily';
  /** Names of the authors of the datasets in this dataset family. */
  authorNames: Array<Scalars['String']['output']>;
  /** Authors of the datasets in this dataset family. */
  authors: Array<Profile>;
  /** Changelog of the datasets in this dataset family. */
  changelog: Scalars['String']['output'];
  /** Citation of the datasets in this dataset family. */
  citation: Scalars['String']['output'];
  /** Class of this dataset family. */
  class: DatasetClass;
  /** Collection of this dataset family. */
  collection?: Maybe<DatasetCollection>;
  /** Datasets in this dataset family. */
  datasets: Array<Dataset>;
  /** Description of the datasets in this dataset family. */
  description: Scalars['String']['output'];
  /** Features of this dataset family. */
  features: Array<DatasetFeature>;
  /** URL to the hero image of this dataset family. */
  heroImage: Scalars['String']['output'];
  /** License of the datasets in this dataset family. */
  license: Scalars['String']['output'];
  /** Datetime when the dataset family was last modified. */
  modifiedAt: Scalars['DatetimeUTC']['output'];
  /** Get available parameter options for a given parameter selection. */
  parameterOptions: DatasetParameterOptions;
  /** URL to the preview image of this dataset family. */
  previewImage: Scalars['String']['output'];
  /** Datetime when the dataset family was first published. */
  publishedAt: Scalars['DatetimeUTC']['output'];
  /** Slug of this dataset family. */
  slug: Scalars['String']['output'];
  /** Source code of the datasets in this dataset family. */
  sourceCode?: Maybe<Scalars['String']['output']>;
  /** Tags of this dataset family. */
  tags: Array<Scalars['String']['output']>;
  /** Title of this dataset family. */
  title: Scalars['String']['output'];
  /** Using the datasets in this dataset family. */
  usingThisDataset: Scalars['String']['output'];
};


export type DatasetFamilyParameterOptionsArgs = {
  currentSelection?: InputMaybe<Scalars['JSON']['input']>;
};

export type DatasetFeature = {
  __typename?: 'DatasetFeature';
  /** Content of this dataset feature. Assumed to be Markdown. */
  content: Scalars['String']['output'];
  /** Slug of this dataset feature. */
  slug: Scalars['String']['output'];
  /** Title of this dataset feature. */
  title: Scalars['String']['output'];
  /** Type of this dataset feature. */
  type: DatasetFeatureType;
};

export enum DatasetFeatureType {
  Data = 'DATA',
  Samples = 'SAMPLES'
}

export type DatasetFile = {
  __typename?: 'DatasetFile';
  /** SHA256 hash of the file. */
  checksumSha256: Scalars['String']['output'];
  /**
   * Public download URL of file. Is null unless status
   * is 'AVAILABLE'.
   */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** Name of file. */
  name: Scalars['String']['output'];
  /** Size of file in bytes. */
  size: Scalars['StrInt']['output'];
  /** Status of the file. */
  status: DatasetFileStatus;
};

export enum DatasetFileStatus {
  Available = 'AVAILABLE',
  FailedVerification = 'FAILED_VERIFICATION',
  PendingUpload = 'PENDING_UPLOAD',
  PendingVerification = 'PENDING_VERIFICATION'
}

export type DatasetFileUpload = {
  __typename?: 'DatasetFileUpload';
  /** Total number of file parts. */
  numParts: Scalars['Int']['output'];
  /** Number of file parts uploaded. */
  numUploadedParts: Scalars['Int']['output'];
  /** Returns up to ``count`` upload parts. */
  uploadParts: Array<DatasetFileUploadPart>;
};


export type DatasetFileUploadUploadPartsArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
};

export type DatasetFileUploadPart = {
  __typename?: 'DatasetFileUploadPart';
  /** Index of the last byte of the part. */
  bytesEnd: Scalars['StrInt']['output'];
  /** Index of the first byte of the part. */
  bytesStart: Scalars['StrInt']['output'];
  /** URL to PUT file data. */
  url: Scalars['String']['output'];
};

export type DatasetParameter = {
  __typename?: 'DatasetParameter';
  /** Name of this dataset parameter. */
  name: Scalars['String']['output'];
};

export type DatasetParameterInput = {
  /** Specifies that a default parameter should be used. */
  default?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the parameter. */
  name: Scalars['String']['input'];
  /** List of accepted parameter values. */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DatasetParameterOptions = {
  __typename?: 'DatasetParameterOptions';
  /** The available parameter options for the given selection. */
  options: Scalars['JSON']['output'];
  /** A valid parameter selection for the class. */
  selection: Scalars['JSON']['output'];
};

export type DatasetParameterValue = {
  __typename?: 'DatasetParameterValue';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Demo = {
  __typename?: 'Demo';
  /** Authors of this demo. */
  authors: Array<Profile>;
  /** Bibtex citation for this demo. */
  bibtexCitation: Scalars['String']['output'];
  /** HTML body of this demo. */
  body: Scalars['String']['output'];
  /** Categories associated with this demo. */
  categories: Array<DemoCategory>;
  /** Description of this demo. */
  description: Scalars['String']['output'];
  /**
   * Returns the URL to the discussion forum for this specific demo.
   * If no URL is provided, it returns the URL to all demo discussions
   */
  discussionForumUrl: Scalars['String']['output'];
  /** Returns the URL to the GitHub repository for this demo. */
  githubUrl: Scalars['String']['output'];
  /** Hardware associated with this demo. */
  hardware: Array<DemoHardware>;
  /** URL to the hero image of this demo. */
  heroImage?: Maybe<Scalars['String']['output']>;
  /** URL to the meta image of this demo. */
  metaImage: Scalars['String']['output'];
  /** Most recent date of modification of this demo. */
  modifiedAt: Scalars['DatetimeUTC']['output'];
  /** Returns the download URL to the demo notebook. */
  notebookUrl: Scalars['String']['output'];
  /** Pull request number of this demo. */
  prNumber: Scalars['Int']['output'];
  /** Whether this demo is a preview. */
  preview: Scalars['Boolean']['output'];
  /** Initial date of publication of this demo. */
  publishedAt: Scalars['DatetimeUTC']['output'];
  /** Slugs of related demos. */
  relatedDemosSlugs: Array<Scalars['String']['output']>;
  /** Returns the runtime of the demo or None if runtime is not provided. */
  runtime?: Maybe<Scalars['Int']['output']>;
  /** Returns the download URL to the demo script. */
  scriptUrl: Scalars['String']['output'];
  /** Unique identifier of this demo. */
  slug: Scalars['String']['output'];
  /** Table of contents of this demo. */
  tableOfContents: Array<TableOfContentsEntry>;
  /** URL to the large thumbnail of this demo. */
  thumbnailLarge: Scalars['String']['output'];
  /** URL to the small thumbnail of this demo. */
  thumbnailSmall: Scalars['String']['output'];
  /** Title of this demo. */
  title: Scalars['String']['output'];
};

export type DemoCategory = {
  __typename?: 'DemoCategory';
  /** Title of this category. */
  title: Scalars['String']['output'];
};

export type DemoHardware = {
  __typename?: 'DemoHardware';
  /** Unique identifier of this hardware. */
  id: Scalars['String']['output'];
  /** URL to the website of this hardware. */
  link: Scalars['String']['output'];
  /** URL to the logo of this hardware. */
  logo: Scalars['String']['output'];
};

export type EventChallengeSchema = {
  __typename?: 'EventChallengeSchema';
  /** URL for a banner image of the challenge. */
  bannerImageUrl?: Maybe<Scalars['String']['output']>;
  /** Event challenges that are configured to block the given event challenge. */
  blockedBy: Array<EventChallengeSchema>;
  /** Category of the event challenge. */
  category: CategorySchema;
  /**
   * Gets the challenge info.
   *
   * A value will be provided if:
   *
   *     - the event challenge is unlocked for the caller
   *     - the event is STARTED or FINISHED
   */
  challenge?: Maybe<ChallengeSchema>;
  /** ID of the challenge. */
  challengeId: Scalars['UUID']['output'];
  /** Slug of the challenge. */
  challengeSlug: Scalars['String']['output'];
  /**
   * Returns:
   *     True: if the player's team has a submission for the event challenge
   *     False: if the player's team does not have any submissions for the event
   *     challenge
   */
  isAttempted: Scalars['Boolean']['output'];
  /**
   * Returns True iff the player's team has completed all the challenges blocking
   * this challenge
   */
  isAvailable: Scalars['Boolean']['output'];
  /**
   * Returns:
   *     True: if the player's team has a ``PASSED`` submission for the event
   *     challenge
   *     False: if the player's team does not have a ``PASSED`` submission for the
   *     event challenge
   */
  isCompleted: Scalars['Boolean']['output'];
  /** Point value of this event challenge. */
  points: Scalars['Int']['output'];
  /**
   * The qBraid redirect URL for this event challenge.
   *
   * Returns ``None`` if:
   *   * The integration is not configured.
   *   * The event challenge is not available to the caller.
   *   * There was an issue fetching the redirect URL.
   */
  qBraidRedirectUrl?: Maybe<Scalars['String']['output']>;
  /** Summary of the challenge. */
  summary: Scalars['String']['output'];
  /** Title of the challenge. */
  title: Scalars['String']['output'];
  /**
   * Returns the event challenge's unlocked_at time.
   * Does not consider the category's unlocked_at time.
   * A ``None`` value implies that the event challenge is unlocked.
   */
  unlockAt?: Maybe<Scalars['DateTime']['output']>;
};


export type EventChallengeSchemaQBraidRedirectUrlArgs = {
  idToken: Scalars['String']['input'];
};

export type EventSchema = {
  __typename?: 'EventSchema';
  /**
   * Gets the categories associated with this event.
   *
   * Returns:
   *     The categories in this event, ordered by ``slug``.
   */
  categories: Array<CategorySchema>;
  /**
   * Gets a category in this event by ID.
   *
   * Returns:
   *     The category in this event.
   *
   * Raises:
   *     ObjectNotFoundError: If there is no category with the given ID.
   */
  category: CategorySchema;
  /** Datetime when the event is scheduled to finish. */
  finishAt?: Maybe<Scalars['DateTime']['output']>;
  /** Datetime when the event finished. */
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID of the event. */
  id: Scalars['UUID']['output'];
  /** Datetime when the event is scheduled to be locked. */
  lockAt?: Maybe<Scalars['DateTime']['output']>;
  /** Datetime when the event was locked. */
  lockedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Maximum size of a team in the event. */
  maxTeamSize?: Maybe<Scalars['Int']['output']>;
  /** Number of categories in the event. */
  numCategories: Scalars['Int']['output'];
  /** Number of challenges in the event. */
  numChallenges: Scalars['Int']['output'];
  /** Number of teams in the event. */
  numTeams: Scalars['Int']['output'];
  /**
   * Gets an available project challenge by ID.
   *
   * Returns ``None`` if:
   *     * It does not exist
   *     * Is not part of this event
   *     * Is not yet started
   *     * Is finished
   *
   * Raises:
   *     EventNotStartedError: If the event is not in the STARTED state.
   */
  projectChallenge?: Maybe<ProjectChallengeSchema>;
  /**
   * Gets the project challenges associated with this event.
   *
   * Only active project challenges are returned, defined by range [start_at, finish_at].
   *
   * Raises:
   *     EventNotStartedError: If the event is not in the STARTED state.
   */
  projectChallenges: ProjectChallengeSchemaPaginationWindow;
  /** Whether the event is open for registration. */
  registrationOpen: Scalars['Boolean']['output'];
  /** Slug of the event. */
  slug: Scalars['String']['output'];
  /** Datetime when the event is scheduled to start. */
  startAt?: Maybe<Scalars['DateTime']['output']>;
  /** Datetime when the event started. */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Status of the event. */
  status: EventStatus;
  /** Whether the teams are locked in the event. */
  teamsLocked: Scalars['Boolean']['output'];
  /** Title of the event. */
  title: Scalars['String']['output'];
};


export type EventSchemaCategoryArgs = {
  categoryId: Scalars['UUID']['input'];
};


export type EventSchemaProjectChallengeArgs = {
  id: Scalars['UUID']['input'];
};


export type EventSchemaProjectChallengesArgs = {
  page?: InputMaybe<PageInput>;
};

export enum EventStatus {
  Created = 'CREATED',
  Finished = 'FINISHED',
  Started = 'STARTED'
}

export type EventSubmissionCreateInput = {
  categoryId: Scalars['UUID']['input'];
  challengeId: Scalars['UUID']['input'];
  submissionCode: Array<Scalars['String']['input']>;
};

export type EventSubmissionFilterInput = {
  byCategory?: InputMaybe<Scalars['UUID']['input']>;
  byChallenge?: InputMaybe<Scalars['UUID']['input']>;
  byPlayer?: InputMaybe<Scalars['UUID']['input']>;
  byStatus?: InputMaybe<SubmissionStatus>;
};

export type EventSubmissionResponse = {
  __typename?: 'EventSubmissionResponse';
  eventSubmission?: Maybe<EventSubmissionSchema>;
  userError?: Maybe<UserErrorSchema>;
};

export type EventSubmissionSchema = {
  __typename?: 'EventSubmissionSchema';
  /** Event challenge of the event submission. */
  eventChallenge: EventChallengeSchema;
  /** ID of the event submission. */
  id: Scalars['UUID']['output'];
  /** Player of the event submission. */
  player: PlayerSchema;
  /** Submission of the event submission. */
  submission: SubmissionSchema;
  /** Team of the event submission. */
  team: TeamSchema;
};

export type EventSubmissionSchemaPaginationWindow = {
  __typename?: 'EventSubmissionSchemaPaginationWindow';
  items: Array<EventSubmissionSchema>;
  totalItems: Scalars['Int']['output'];
};

export type GenericContent = Content & {
  __typename?: 'GenericContent';
  authors: Array<AuthorNameProfile>;
  categories?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  link: Scalars['String']['output'];
  modifiedAt: Scalars['DatetimeUTC']['output'];
  publishedAt: Scalars['DatetimeUTC']['output'];
  related: Array<Content>;
  slug: Scalars['String']['output'];
  thumbnail?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: ContentType;
};


export type GenericContentRelatedArgs = {
  contentTypes?: InputMaybe<Array<ContentType>>;
  count: Scalars['Int']['input'];
};

export enum HandleAvailability {
  Available = 'AVAILABLE',
  Invalid = 'INVALID',
  Unavailable = 'UNAVAILABLE'
}

export type LeaderboardCategorySchema = {
  __typename?: 'LeaderboardCategorySchema';
  cardIconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  /**
   * A Category is locked iff:
   *     unlocked_at is not null
   *     unlocked_at is in the future
   */
  isLocked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  numChallenges: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
  unlockedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LeaderboardTeamCategoryPerformanceSchema = {
  __typename?: 'LeaderboardTeamCategoryPerformanceSchema';
  category: LeaderboardCategorySchema;
  index: Scalars['Int']['output'];
  numberSolved: Scalars['Int']['output'];
  rank: Scalars['Int']['output'];
  team: LeaderboardTeamSchema;
  timePenalty: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
};

export type LeaderboardTeamPerformanceSchema = {
  __typename?: 'LeaderboardTeamPerformanceSchema';
  categoryPerformances: Array<LeaderboardTeamCategoryPerformanceSchema>;
  index: Scalars['Int']['output'];
  numberSolved: Scalars['Int']['output'];
  peakRank?: Maybe<Scalars['Int']['output']>;
  rank: Scalars['Int']['output'];
  team: LeaderboardTeamSchema;
  timePenalty: Scalars['Int']['output'];
  totalPoints: Scalars['Int']['output'];
};

export type LeaderboardTeamPerformanceSchemaPaginationWindow = {
  __typename?: 'LeaderboardTeamPerformanceSchemaPaginationWindow';
  items: Array<LeaderboardTeamPerformanceSchema>;
  totalItems: Scalars['Int']['output'];
};

export type LeaderboardTeamSchema = {
  __typename?: 'LeaderboardTeamSchema';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

export type MessageInput = {
  body: Scalars['String']['input'];
  resolvesChat?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MessageResponse = {
  __typename?: 'MessageResponse';
  message?: Maybe<MessageSchema>;
  userError?: Maybe<UserErrorSchema>;
};

export type MessageSchema = {
  __typename?: 'MessageSchema';
  /** Body of the message. */
  body: Scalars['String']['output'];
  /** Timestamp when the message was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Whether this message is hidden. */
  hidden: Scalars['Boolean']['output'];
  /** ID of the message. */
  id: Scalars['UUID']['output'];
  /** Player who sent the message. */
  player: PlayerSchema;
  /** Whether this message resolves the chat. */
  resolvesChat?: Maybe<Scalars['Boolean']['output']>;
};

export type MessageSchemaPaginationWindow = {
  __typename?: 'MessageSchemaPaginationWindow';
  items: Array<MessageSchema>;
  totalItems: Scalars['Int']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Accept a pending certificate owned by the calling user. */
  acceptPendingCertificate: MutationResponse;
  /**
   * Deletes the caller's ``Profile`` avatar.
   *
   * Raises:
   *
   *     RuntimeError: if the caller does not have a profile
   *
   * User Errors:
   *
   *     NoAvatarToDelete: if the caller does not have an avatar
   */
  avatarDelete: MutationResponse;
  /**
   * Updates the caller's ``Profile`` avatar.
   *
   * Raises:
   *
   *     RuntimeError: if the caller does not have a profile
   *
   * Returns:
   *
   *     URL of the avatar.
   *
   * User Errors:
   *
   *     InvalidValetReceipt: if the given Valet receipt is invalid
   *
   *     InvalidAvatarUser: if the user ID claim in the Valet receipt does not
   *         match the user ID of the caller
   *
   *     InvalidAvatarSize: if the file size of the avatar is too large
   *
   *     InvalidAvatarType: if the (image) type of the avatar is unsupported
   */
  avatarUpdate: StrPayloadResponse;
  /**
   * Appends a message to a chat.
   *
   * Raises:
   *     ObjectNotFoundError: if the chat does not exist
   *     ObjectNotFoundError: if the caller is not authorized to view the chat
   */
  chatAppend: ChatResponse;
  /**
   * Assigns a chat to a specified moderator player, or None.
   *
   * Raises:
   *     ObjectNotFoundError: if the chat does not exist
   *     ObjectNotFoundError: if the assigned player does not exist
   *
   * UserErrors:
   *     - if ``assignee`` is not a moderator in the chat event
   */
  chatAssign: ChatResponse;
  /**
   * Creates a chat on behalf of the requestor.
   *
   * Raises:
   *     ObjectNotFoundError: if a challenge is provided but could not be found
   *     ObjectNotFoundError: if a submission is provided but could not be found
   *
   * User Errors:
   *
   *     - challenge and submission.challenge are inconsistent
   *     - creator has does not belong to a team and scope is ``TEAM``
   */
  chatCreate: ChatResponse;
  /**
   * Uploads a chat file to S3, and returns the url of the bucket-hosted content.
   *
   * Follows the GraphQL multipart file upload specified by
   * https://github.com/jaydenseric/graphql-multipart-request-spec
   *
   * Raises:
   *     ValueError: if the user does not have a player
   *     ValueError: if the file is larger than the server limit
   *     RuntimeError: if the upload to S3 fails
   */
  chatFileUpload: Scalars['String']['output'];
  /**
   * Locks a chat, preventing further discussion.
   *
   * Raises:
   *     ObjectNotFoundError: if the chat does not exist
   */
  chatLockUpdate: ChatResponse;
  /**
   * Allows a moderator to change the visibility of a chat message.
   *
   * Raises:
   *     ObjectNotFoundError: if the message does not exist
   *     ObjectNotFoundError: if the moderator does not belong to the chat event
   */
  chatMessageVisibility: MessageResponse;
  codebookSubmissionCreate: CodebookSubmission;
  /** Start a dataset file upload. */
  datasetFileUploadCreate: MutationResponse;
  /**
   * Create a new submission. Requires the user to be registered.
   *
   * Returns: a ``EventSubmissionResponse`` containing the created submission,
   *     if successful.
   *
   * User Errors:
   *     UserErrorEventNotAcceptingSubmissions: if the event is not started
   *     UserErrorPlayerNotInTeam: if the user is not in a team
   *     UserErrorChallengeLocked: if the challenge is locked
   *     UserErrorSubmissionInvalidCodeBlocks: if the number of submitted
   *         code blocks differs from the expected number of code blocks
   *     UserErrorCodeBlockTooLong: if a submitted code block is too long
   *     UserErrorTooManySubmissionsInProgress: if the user has more than
   *         the maximum number of pending submissions
   */
  eventSubmissionCreate: EventSubmissionResponse;
  /**
   * Create a password change ticket for the calling user.
   *
   * User Errors:
   *
   *     PasswordUpdateFailed: if the operation fails
   */
  passwordChangeTicket: StrPayloadResponse;
  /**
   * Creates a player in an ``event`` for the currently authenticated ``user``.
   * The event is specified by the ``X-Event-ID`` header.
   *
   * Returns a ``PlayerResponse`` with the created player, if successful.
   *
   * UserErrors:
   *     UserErrorEventIsFinished: if the event status is FINISHED
   *     UserErrorEventRegistrationNotOpen: if the event registration is not open
   *     UserErrorAlreadyRegistered: if the user already has a player in the event
   */
  playerCreate: PlayerResponse;
  /**
   * Creates a profile for the caller.
   *
   * Args:
   *     model: the profile to create
   *     sessionToken: session token provided by Auth0
   *
   * Fails if:
   *  * The session token could not be decoded
   *  * The session token has expired
   *  * The session token signature could not be verified
   *  * A profile with the given id already exists
   *  * The handle is not valid or available
   *  * The first/last name are invalid
   *  * The persona_other is invalid.
   */
  profileCreate: MutationResponse;
  /**
   * Deletes the calling user's profile and auth0 account.
   *
   * Note: This action cannot be reversed. A user can still re-register and create a new
   *   profile if they wish.
   *
   * Raises:
   *
   *     RuntimeError: if the caller does not have a profile
   *
   * User Errors:
   *
   *     PleaseConfirmAccountDeletion: if ``confirm`` is ``False``
   *
   *     AccountDeletionError: if the user's auth0 account could not be deleted
   */
  profileDelete: MutationResponse;
  /**
   * Updates the caller's ``Profile``.
   *
   * Raises:
   *     RuntimeError: if the caller does not have a profile
   */
  profileUpdate: MutationResponse;
  /** Creates a new project submission on behalf of the caller's team. */
  projectSubmissionCreate: ProjectSubmissionResponse;
  /**
   * Creates a standalone submission on behalf of the calling user.
   *
   * Returns:
   *     A ``StandaloneSubmissionResponse`` containing the created submission, if
   *     successful.
   *
   * User Errors:
   *     UserErrorSubmissionInvalidCodeBlocks: if the number of submitted
   *         code blocks differs from the expected number of code blocks
   *     UserErrorCodeBlockTooLong: if a submitted code block is too long
   */
  standaloneSubmissionCreate: StandaloneSubmissionResponse;
  /**
   * Creates a team with the given ``name`` and adds the current ``player`` as a
   * member.
   *
   * Returns a ``TeamResponse`` with the created team, if successful.
   *
   * User Errors:
   *     UserErrorEventRegistrationNotOpen: if the event registration is not open
   *     UserErrorEventLocked: if the event's teams are locked
   *     UserErrorEventIsFinished: if the event status is finished
   *     UserErrorPlayerAlreadyOnTeam: if the player is already a member of a team
   *     UserErrorTeamNameTaken: if the team name is already taken
   */
  teamCreate: TeamResponse;
  /**
   * Adds the current ``player`` to the team by ``joinCode``.
   *
   * Returns a ``TeamResponse`` with the joined team, if successful.
   *
   * User Errors:
   *     UserErrorEventRegistrationNotOpen: if the event registration is not open
   *     UserErrorEventLocked: if the event's teams are locked
   *     UserErrorEventIsFinished: if the event status is FINISHED
   *     UserErrorPlayerAlreadyOnTeam: if the player is already a member of a team
   *     UserErrorTeamNoSuchJoinCode: if the requested team does not exist or is
   *     soft-deleted
   *     UserErrorTeamLocked: if the team is locked
   *     UserErrorTeamMaxSize: if there is no more room on the team
   */
  teamJoin: TeamResponse;
  /**
   * Removes the ``player`` from their current team.
   *
   * Returns a ``TeamResponse`` with a null ``team``, if successful.
   *
   * User Errors:
   *     UserErrorEventLocked: if the event's teams are locked
   *     UserErrorPlayerNoTeam: if the player is not a member of a team
   *     UserErrorEventIsFinished: if the event's status is FINISHED
   */
  teamLeave: TeamResponse;
  /**
   * Toggles the ``isLocked`` property of the current ``player``'s team.
   *
   * Returns a ``TeamResponse`` with the updated team, if successful.
   *
   * User Errors:
   *     UserErrorEventLocked: if the event's teams are locked
   *     UserErrorPlayerNoTeam: if the player is not a member of a team
   *     UserErrorEventIsFinished: if the event's status is FINISHED
   */
  teamLockToggle: TeamResponse;
  /**
   * Set the visibility of individual certificate awards on the calling user's public
   * profile
   */
  updateCertificateAwardVisibility: AwardedCertificatePayloadResponse;
  /**
   * Update the recipient info of a pending certificate owned by the
   * calling user.
   */
  updateCertificateRecipientInfo: UpdateCertificateRecipientInfoResponsePayloadResponse;
  /**
   * Asychronously sends a verification email to the calling user.
   *
   * User Errors:
   *
   *     VerificationEmailError: if the operation fails
   */
  verificationEmail: MutationResponse;
};


export type MutationAcceptPendingCertificateArgs = {
  awardId: Scalars['CertificateAwardID']['input'];
};


export type MutationAvatarUpdateArgs = {
  receipt: Scalars['ValetReceipt']['input'];
};


export type MutationChatAppendArgs = {
  chatId: Scalars['UUID']['input'];
  message: MessageInput;
};


export type MutationChatAssignArgs = {
  chatId: Scalars['UUID']['input'];
  playerId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationChatCreateArgs = {
  chat: ChatCreateInput;
};


export type MutationChatFileUploadArgs = {
  fileUpload: Scalars['Upload']['input'];
};


export type MutationChatLockUpdateArgs = {
  chatId: Scalars['UUID']['input'];
  locked: Scalars['Boolean']['input'];
};


export type MutationChatMessageVisibilityArgs = {
  hidden: Scalars['Boolean']['input'];
  messageId: Scalars['UUID']['input'];
};


export type MutationCodebookSubmissionCreateArgs = {
  model: CodebookSubmissionModel;
};


export type MutationDatasetFileUploadCreateArgs = {
  checksumSha256: Scalars['String']['input'];
  name: Scalars['String']['input'];
  size: Scalars['StrInt']['input'];
};


export type MutationEventSubmissionCreateArgs = {
  submission: EventSubmissionCreateInput;
};


export type MutationPlayerCreateArgs = {
  meta: Scalars['JSON']['input'];
};


export type MutationProfileCreateArgs = {
  model: ProfileCreateInput;
  sessionToken: Scalars['String']['input'];
};


export type MutationProfileDeleteArgs = {
  confirm: Scalars['Boolean']['input'];
};


export type MutationProfileUpdateArgs = {
  model: ProfileUpdateInput;
};


export type MutationProjectSubmissionCreateArgs = {
  model: ProjectSubmissionInput;
};


export type MutationStandaloneSubmissionCreateArgs = {
  model: StandaloneSubmissionCreateInput;
};


export type MutationTeamCreateArgs = {
  name: Scalars['String']['input'];
};


export type MutationTeamJoinArgs = {
  joinCode: Scalars['String']['input'];
};


export type MutationUpdateCertificateAwardVisibilityArgs = {
  awardId: Scalars['CertificateAwardID']['input'];
  public: Scalars['Boolean']['input'];
};


export type MutationUpdateCertificateRecipientInfoArgs = {
  awardId: Scalars['CertificateAwardID']['input'];
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
};


export type MutationVerificationEmailArgs = {
  sessionToken: Scalars['String']['input'];
};

export type MutationResponse = {
  __typename?: 'MutationResponse';
  userError?: Maybe<UserErrorSchema>;
};

export type PageInput = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type PendingCertificate = {
  __typename?: 'PendingCertificate';
  /** When this award was issued to the user. */
  awardedAt: Scalars['DatetimeUTC']['output'];
  /** The certificate definition that was granted by this award. */
  definition: CertificateDefinition;
  /** Unique ID for this certificate award. */
  id: Scalars['CertificateAwardID']['output'];
  /** The recipient information for this certificate. */
  recipientInfo: CertificateRecipientInfo;
};

export enum PersonaType {
  Developer = 'DEVELOPER',
  Educator = 'EDUCATOR',
  Hobbyist = 'HOBBYIST',
  Other = 'OTHER',
  Researcher = 'RESEARCHER',
  Student = 'STUDENT'
}

export type PersonaTypeListField = {
  value: Array<PersonaType>;
};

export type PlayerResponse = {
  __typename?: 'PlayerResponse';
  player?: Maybe<PlayerSchema>;
  userError?: Maybe<UserErrorSchema>;
};

export type PlayerSchema = {
  __typename?: 'PlayerSchema';
  /** Whether the player was deleted. */
  deleted: Scalars['Boolean']['output'];
  /** ID of the player. */
  id: Scalars['UUID']['output'];
  /** Whether the player is a moderator. */
  moderator: Scalars['Boolean']['output'];
  /** Profile of the player. */
  profile: Profile;
  /** Team of the player. */
  team?: Maybe<TeamSchema>;
};

export type PlayerSchemaPaginationWindow = {
  __typename?: 'PlayerSchemaPaginationWindow';
  items: Array<PlayerSchema>;
  totalItems: Scalars['Int']['output'];
};

export type Profile = {
  __typename?: 'Profile';
  /** The bio of the profile. */
  about?: Maybe<Scalars['String']['output']>;
  /** The affiliation of the profile. */
  affiliation?: Maybe<Scalars['String']['output']>;
  /** The avatar URL of the profile. */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** The badges awarded to the profile. */
  awardedBadges: AwardedBadgePaginationWindow;
  /** Get an accepted certificate owned by the profile. Only visible to the profile owner. */
  awardedCertificate?: Maybe<AwardedCertificate>;
  /**
   * The accepted certificates owned by the profile, in descending order of awardedAt.
   * Only visible to the profile owner.
   */
  awardedCertificates: Array<AwardedCertificate>;
  /** The creation time of the profile. */
  createdAt: Scalars['DatetimeUTC']['output'];
  /** The email address of the profile. Only visible to the profile owner. */
  email?: Maybe<Scalars['String']['output']>;
  /** The first name of the profile. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The handle (username) of the profile. */
  handle: Scalars['String']['output'];
  /** The headline of the profile. */
  headline?: Maybe<Scalars['String']['output']>;
  /** The ID of the profile. */
  id: Scalars['UserID']['output'];
  /** The last name of the profile. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The number of blogs and demos the profile has authored. */
  numContributions: Scalars['Int']['output'];
  /**
   * The pending certificates owned by the profile, in descending order of awardedAt.
   * Only visible to the profile owner.
   */
  pendingCertificates: Array<PendingCertificate>;
  /**
   * The self-identified free-form persona of the profile. Only visible to the profile
   * owner.
   */
  personaOther?: Maybe<Scalars['String']['output']>;
  /** The personal URL of the profile. */
  personalUrl?: Maybe<Scalars['String']['output']>;
  /** The self-identified personas of the profile. Only visible to the profile owner. */
  personas?: Maybe<Array<PersonaType>>;
  /** The pronouns of the profile. */
  pronouns?: Maybe<Scalars['String']['output']>;
  /** The public (and accepted) certificates awarded to the profile. */
  publicCertificates: AwardedCertificateBasePaginationWindow;
  /** The title/role of the profile. */
  role?: Maybe<Scalars['String']['output']>;
  /** The social accounts of the profile. */
  socialAccounts: Array<ProfileSocialAccountBase>;
};


export type ProfileAwardedBadgesArgs = {
  page?: InputMaybe<PageInput>;
};


export type ProfileAwardedCertificateArgs = {
  id: Scalars['CertificateAwardID']['input'];
};


export type ProfilePublicCertificatesArgs = {
  page?: InputMaybe<PageInput>;
};

export type ProfileContent = Content & {
  __typename?: 'ProfileContent';
  authors: Array<AuthorNameProfile>;
  categories?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  link: Scalars['String']['output'];
  modifiedAt: Scalars['DatetimeUTC']['output'];
  profile: Profile;
  publishedAt: Scalars['DatetimeUTC']['output'];
  related: Array<Content>;
  slug: Scalars['String']['output'];
  thumbnail?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: ContentType;
};


export type ProfileContentRelatedArgs = {
  contentTypes?: InputMaybe<Array<ContentType>>;
  count: Scalars['Int']['input'];
};

export type ProfileCreateInput = {
  /**
   * Optional first name.
   *
   * Must be between 1-25 characters (inclusive).
   */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /**
   * The user's desired handle, a.k.a. "username".
   *
   * Must be between 3-20 characters (inclusive).
   * May only contain alphanumeric characters and underscores.
   */
  handle: Scalars['String']['input'];
  /**
   * Optional last name.
   *
   * Must be between 1-25 characters (inclusive).
   */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional freeform self-identification.
   *
   * Must be between 1-50 characters (inclusive).
   */
  personaOther?: InputMaybe<Scalars['String']['input']>;
  /**
   * The user's self-selected personas.
   *
   * May be an empty list.
   */
  personas: Array<PersonaType>;
  /**
   * Other information collected during onboarding.
   *
   * Required for analytic purposes.
   */
  survey: ProfileCreateSurveyInput;
};

export type ProfileCreateSurveyInput = {
  /** Does the user have experience using PennyLane? */
  usesPennylane: Scalars['Boolean']['input'];
};

export type ProfileSocialAccountBase = {
  __typename?: 'ProfileSocialAccountBase';
  /** The type of the profile social account. */
  type: ProfileSocialAccountType;
  /** The URL of the profile social account. */
  url: Scalars['String']['output'];
};

export enum ProfileSocialAccountType {
  Github = 'GITHUB',
  GoogleScholar = 'GOOGLE_SCHOLAR',
  Linkedin = 'LINKEDIN',
  Twitter = 'TWITTER'
}

export type ProfileSocialAccountUpdateInput = {
  /** The type of the social account. */
  type: ProfileSocialAccountType;
  /**
   * The URL of the social account.
   *
   * Must be between 0-256 characters (inclusive).
   */
  url: Scalars['String']['input'];
};

export type ProfileSocialAccountUpdateInputListField = {
  value: Array<ProfileSocialAccountUpdateInput>;
};

export type ProfileUpdateInput = {
  /**
   * If provided, will update the user's bio.
   *
   * Must be between 0-3000 characters (inclusive).
   */
  about?: InputMaybe<StrOptionalField>;
  /**
   * If provided, will update the user's affiliation.
   *
   * Must be between 0-100 characters (inclusive).
   */
  affiliation?: InputMaybe<StrOptionalField>;
  /**
   * If provided, will update the user's first name.
   *
   * Must be between 1-25 characters (inclusive).
   */
  firstName?: InputMaybe<StrOptionalField>;
  /**
   * If provided, will update the user's desired handle, a.k.a. "username".
   *
   * Must be between 3-20 characters (inclusive).
   * May only contain alphanumeric characters and underscores.
   */
  handle?: InputMaybe<StrField>;
  /**
   * If provided, will update the user's headline.
   *
   * Must be between 0-250 characters (inclusive).
   */
  headline?: InputMaybe<StrOptionalField>;
  /**
   * If provided, will update the user's last_name.
   *
   * Must be between 1-25 characters (inclusive).
   */
  lastName?: InputMaybe<StrOptionalField>;
  /**
   * If provided, will update the user's freeform self-identification.
   *
   * Must be between 1-50 characters (inclusive).
   */
  personaOther?: InputMaybe<StrOptionalField>;
  /**
   * If provided, will update the user's personal URL.
   *
   * Must be between 0-256 characters (inclusive).
   */
  personalUrl?: InputMaybe<StrOptionalField>;
  /**
   * If provided, will update the user's personas.
   *
   * May be an empty list.
   */
  personas?: InputMaybe<PersonaTypeListField>;
  /**
   * If provided, will update the user's pronouns.
   *
   * Must be between 0-20 characters (inclusive).
   */
  pronouns?: InputMaybe<StrOptionalField>;
  /**
   * If provided, will update the user's role.
   *
   * Must be between 0-100 characters (inclusive).
   */
  role?: InputMaybe<StrOptionalField>;
  /**
   * If provided, will update the user's social accounts.
   *
   * May be an empty list.
   */
  socialAccounts?: InputMaybe<ProfileSocialAccountUpdateInputListField>;
};

export type ProjectChallengeSchema = {
  __typename?: 'ProjectChallengeSchema';
  /** Description of the project challenge. */
  description?: Maybe<Scalars['String']['output']>;
  /** Datetime when the project challenge is scheduled to finish. */
  finishAt?: Maybe<Scalars['DateTime']['output']>;
  /** ID of the project challenge. */
  id: Scalars['UUID']['output'];
  /** Display image of the project challenge. */
  image?: Maybe<Scalars['String']['output']>;
  /** Name of the project challenge. */
  name: Scalars['String']['output'];
  /** Slug of the project challenge. */
  slug: Scalars['String']['output'];
  /** Datetime when the project challenge is scheduled to start. */
  startAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProjectChallengeSchemaPaginationWindow = {
  __typename?: 'ProjectChallengeSchemaPaginationWindow';
  items: Array<ProjectChallengeSchema>;
  totalItems: Scalars['Int']['output'];
};

export type ProjectSubmissionInput = {
  /** A JWT receipt from valet containing the file info for the submission. */
  fileReceipt: Scalars['String']['input'];
  /** Attached metadata. */
  meta: Scalars['JSON']['input'];
  /**
   * Project challenges to associate with this submission.
   * Must contain at least one element.
   */
  projectChallengeIds: Array<Scalars['UUID']['input']>;
  /** A title for this submission. */
  title: Scalars['String']['input'];
};

export type ProjectSubmissionResponse = {
  __typename?: 'ProjectSubmissionResponse';
  projectSubmission?: Maybe<ProjectSubmissionSchema>;
  userError?: Maybe<UserErrorSchema>;
};

export type ProjectSubmissionSchema = {
  __typename?: 'ProjectSubmissionSchema';
  /** Datetime when the project submission was made. */
  createdAt: Scalars['DateTime']['output'];
  /** File ID of the project submission. */
  fileId: Scalars['UUID']['output'];
  /** ID of the project submission. */
  id: Scalars['UUID']['output'];
  /** Metadata of the project submission. */
  meta: Scalars['JSON']['output'];
  /** Project challenges associated with this submission. */
  projectChallenges: Array<ProjectChallengeSchema>;
  /** Player that made the project submission. */
  submittedBy: PlayerSchema;
  /** Team of the project submission. */
  team: TeamSchema;
  /** Title of the project submission. */
  title: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  /**
   * Returns the blog post with the given `slug`, or `None` if no such blog post
   * exists.
   */
  blogPost?: Maybe<BlogPost>;
  /**
   * Returns the most recent blog post associated with a release, or `None` if no such
   * blog post exists.
   */
  blogPostForLatestRelease?: Maybe<BlogPost>;
  /** Return the unique categories with submissions from the calling player's team. */
  categoryFilter: Array<CategorySchema>;
  /** Return the unique challenges with a submission by the calling player's team. */
  challengeFilter: Array<EventChallengeSchema>;
  /**
   * Gets the chat with the given ID.
   *
   * Raises:
   *     ObjectNotFoundError: if there is no chat with the given ID
   *     ObjectNotFoundError: if the caller is not authorized to access the chat
   */
  chat: ChatSchema;
  /** Gets the filter options for the ``chats`` query. */
  chatFilterOptions: ChatFilterOptionsSchema;
  /**
   * Gets the paginated chats with the given status that match the specified filters.
   *
   * Raises:
   *     ResolverError: if the caller specifies an unauthorized filter
   */
  chats: ChatSchemaPaginationWindow;
  /**
   * The topics attempted (but not completed) by the caller, in descending
   * order of last submission time (i.e., most recent to least recent).
   *
   * Resolves to ``null`` if the "Authorization" header is missing or invalid.
   */
  codebookAttemptedTopics?: Maybe<Array<CodebookTopic>>;
  /** Gets one module by slug. */
  codebookModule?: Maybe<CodebookModule>;
  /** Gets all modules. */
  codebookModules: Array<CodebookModule>;
  /** Gets one path by slug. */
  codebookPath?: Maybe<CodebookPath>;
  /** Gets all paths. */
  codebookPaths: Array<CodebookPath>;
  /** Gets one submission by id. */
  codebookSubmission?: Maybe<CodebookSubmission>;
  /** Returns the compilation with the given `slug`, or `None` if no such compilation exists. */
  compilation?: Maybe<Compilation>;
  /** Returns a list of all compilations. */
  compilations: Array<Compilation>;
  /** Fetches content by slug and type. */
  content?: Maybe<AnyContent>;
  /** Fetches content by slugs and types. */
  contentBySlugsAndTypes: Array<AnyContent>;
  /** Fetches content by type. */
  contentByType: Array<AnyContent>;
  /** Get a dataset by its unique ID. */
  dataset?: Maybe<Dataset>;
  /** Gets the dataset class with the given ID. */
  datasetClass?: Maybe<DatasetClass>;
  /** Gets all dataset classes. */
  datasetClasses: Array<DatasetClass>;
  /** Gets the dataset collection with the given slug. */
  datasetCollection?: Maybe<DatasetCollection>;
  /** Gets all dataset collections. */
  datasetCollections: Array<DatasetCollection>;
  /** Gets all dataset families. */
  datasetFamilies: Array<DatasetFamily>;
  /** Gets the dataset family with the given slug. */
  datasetFamily?: Maybe<DatasetFamily>;
  /** Return a file owned by the calling user with given name. */
  datasetFile?: Maybe<DatasetFile>;
  /**
   * Return upload information for a pending file owned by the calling user,
   * with given name.
   */
  datasetFileUpload?: Maybe<DatasetFileUpload>;
  /** Return a the list of files owned by the calling user. */
  datasetFiles: Array<DatasetFile>;
  /** Gets the dataset collections (and families not in a collection). */
  datasetSummary: Array<DatasetCollectionDatasetFamily>;
  /** Returns the demo with the given `slug`, or `None` if no such demo exists. */
  demo?: Maybe<Demo>;
  /** Returns a list of all demo categories. */
  demoCategories: Array<Scalars['String']['output']>;
  /** Returns a list of all production demo slugs and their last modified dates for sitemap generation. */
  demoSitemapData: Array<SiteMapEntry>;
  /**
   * Get an event from the `X-Event-ID` header.
   *
   * Raises:
   *     HeaderMissingError, if 'X-Event-ID' header is not provided
   *     ValueError, if 'X-Event-ID' is not a valid UUID
   *     ObjectNotFoundError, if 'X-Event-ID' is not the ID of an event,
   *         or it refers to a non-public event and the calling user is
   *         not admin.
   */
  event: EventSchema;
  /**
   * Gets the event submission with the given ID.
   *
   * Raises:
   *     ObjectNotFoundError: if no submission with the given ID exists
   */
  eventSubmission: EventSubmissionSchema;
  /**
   * Gets a page of event submissions for the given team that matches the
   * specified filters.
   *
   * Raises:
   *     ObjectNotFoundError: if no team with the given ID exists
   */
  eventSubmissions: EventSubmissionSchemaPaginationWindow;
  events: Array<EventSchema>;
  /** Returns a list of all featured demos. */
  featuredDemos: Array<Demo>;
  /** Checks that the given handle is valid and available. */
  handleIsAvailable: HandleAvailability;
  /**
   * Fetches the performance of teams, the number of results returned is
   * determined by the page offset and limit parameters.
   *
   * Raises:
   *     ObjectNotFoundError: if the event is not accessible to the caller
   *     NotImplementedError: if the event has not started yet
   *     NotImplementedError: if the event does not have any challenges
   */
  leaderboard: LeaderboardTeamPerformanceSchemaPaginationWindow;
  /**
   * Fetches performance for a given team_id and category_id.
   *
   * Raises:
   *     ObjectNotFoundError: if the caller is not registered for the event
   *     NotImplementedError: if the event has not started yet
   *     ObjectNotFoundError: if there is no match for the team and category ID
   */
  leaderboardTeamCategoryPerformance: LeaderboardTeamCategoryPerformanceSchema;
  /**
   * Fetches performance for a given team_id.
   *
   * Raises:
   *     NotImplementedError: if the event has not started yet
   *     NotImplementedError: if the event does not have any challenges
   *     ObjectNotFoundError: if the team does not exist
   *     RuntimeError: if the team has not yet been added to the leaderboard
   */
  leaderboardTeamPerformance: LeaderboardTeamPerformanceSchema;
  /**
   * Gets the ``moderator`` players for the event specified by ``X-Event-ID``.
   * Requires the requesting player to be a ``moderator``.
   */
  moderators: Array<PlayerSchema>;
  /** Returns all options for ``PersonaType``, sorted alphabetically. */
  personaTypes: Array<PersonaType>;
  /**
   * Gets a player created by the requesting user, who is registered for the event
   * specified by ``X-Event-ID``.
   *
   * Returns:
   *     A player, or ``null`` if no player exists for the calling user, or the
   *     player is deleted.
   */
  player?: Maybe<PlayerSchema>;
  /**
   * Return the unique players that have submissions and belong to the calling
   * player's team.
   */
  playerFilter: Array<PlayerSchema>;
  /**
   * Returns a profile with the given user ID or (case-insensitive) handle, or
   * ``None`` if no profile exists with those parameters.
   *
   * Raises:
   *     ValueError: if the user ID and handle are both missing
   *     ValueError: if the user ID and handle are both present
   */
  profile?: Maybe<Profile>;
  /** Returns all known user handles. */
  profileHandles: Array<Scalars['String']['output']>;
  /** Returns true if there is a completed profile belonging to the user. */
  profileIsComplete: Scalars['Boolean']['output'];
  /**
   * Returns a list of public profiles matching the provided ``user_ids``.
   *
   * If a user ID does not correspond to any profile, it is skipped.
   */
  profiles: Array<Profile>;
  /** Gets content which satisfies the given search parameters. */
  search: AnyContentPaginationWindow;
  /** Provides values for search filtering. */
  searchFilterOptions: SearchFilterOptions;
  /**
   * Resolves a standalone challenge configuration by challenge_id.
   *
   * Raises:
   *     ObjectNotFound: if the standalone challenge configuration does not exist
   */
  standaloneChallenge: StandaloneChallengeSchema;
  /**
   * Resolves a standalone challenge configuration by challenge slug
   *
   * Raises:
   *     ObjectNotFound: if the standalone challenge configuration does not exist
   */
  standaloneChallengeBySlug: StandaloneChallengeSchema;
  /** Resolves all available standalone challenge categories. */
  standaloneChallengeCategories: Array<StandaloneChallengeCategorySchema>;
  /** Resolves all standalone challenge by a given category. */
  standaloneChallengeCategory: StandaloneChallengeCategorySchema;
  /**
   * Resolves all available standalone challenges in descending order of
   * publication time (followed by ascending order of slug as a tiebreaker).
   */
  standaloneChallenges: Array<StandaloneChallengeSchema>;
  /** Resolves a standalone event by slug. */
  standaloneEvent?: Maybe<StandaloneEventSchema>;
  /**
   * Returns a standalone submission created by the calling user.
   *
   * Raises:
   *     ObjectNotFoundError: if the standalone submission does not exist
   *     ObjectNotFoundError: if the standalone submission was not created by the
   *     calling user
   */
  standaloneSubmission: StandaloneSubmissionSchema;
  /**
   * Returns paginated standalone submissions created by the calling user.
   *
   * Args:
   *
   *     ``challenge_id``: If provided, will only return submissions made to the
   *         standalone challenge with the given challenge id.
   */
  standaloneSubmissions: StandaloneSubmissionSchemaPaginationWindow;
  /** Return the unique values of submission statuses for the caller's team. */
  statusFilter: Array<SubmissionStatus>;
  /**
   * Returns the user's current team, or ``None`` if it does not exist.
   *
   * Requires ``X-Event-ID`` header to determine which team to return.
   */
  team?: Maybe<TeamSchema>;
  /**
   * Returns the teams in the moderator's event.
   *
   * Raises:
   *     ObjectNotFoundError: if the event does not exist
   */
  teams: Array<TeamSchema>;
};


export type QueryBlogPostArgs = {
  slug: Scalars['String']['input'];
};


export type QueryChatArgs = {
  chatId: Scalars['UUID']['input'];
};


export type QueryChatsArgs = {
  filters?: InputMaybe<ChatFilterInput>;
  page?: InputMaybe<PageInput>;
};


export type QueryCodebookModuleArgs = {
  slug: Scalars['String']['input'];
};


export type QueryCodebookPathArgs = {
  slug: Scalars['String']['input'];
};


export type QueryCodebookSubmissionArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryCompilationArgs = {
  slug: Scalars['String']['input'];
};


export type QueryContentArgs = {
  slug: Scalars['String']['input'];
  type: ContentType;
};


export type QueryContentBySlugsAndTypesArgs = {
  input: Array<ContentSlugAndTypeInput>;
};


export type QueryContentByTypeArgs = {
  type: ContentType;
};


export type QueryDatasetArgs = {
  id: Scalars['String']['input'];
};


export type QueryDatasetClassArgs = {
  id: Scalars['String']['input'];
};


export type QueryDatasetCollectionArgs = {
  slug: Scalars['String']['input'];
};


export type QueryDatasetFamilyArgs = {
  slug: Scalars['String']['input'];
};


export type QueryDatasetFileArgs = {
  name: Scalars['String']['input'];
};


export type QueryDatasetFileUploadArgs = {
  name: Scalars['String']['input'];
};


export type QueryDemoArgs = {
  prNumber?: InputMaybe<Scalars['Int']['input']>;
  slug: Scalars['String']['input'];
};


export type QueryEventSubmissionArgs = {
  submissionId: Scalars['UUID']['input'];
};


export type QueryEventSubmissionsArgs = {
  filters?: InputMaybe<EventSubmissionFilterInput>;
  page?: InputMaybe<PageInput>;
  teamId: Scalars['UUID']['input'];
};


export type QueryEventsArgs = {
  registrationOpen?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<EventStatus>;
};


export type QueryHandleIsAvailableArgs = {
  handle: Scalars['String']['input'];
};


export type QueryLeaderboardArgs = {
  page?: InputMaybe<PageInput>;
};


export type QueryLeaderboardTeamCategoryPerformanceArgs = {
  categoryId: Scalars['UUID']['input'];
  teamId: Scalars['UUID']['input'];
};


export type QueryLeaderboardTeamPerformanceArgs = {
  teamId: Scalars['UUID']['input'];
};


export type QueryProfileArgs = {
  handle?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UserID']['input']>;
};


export type QueryProfileIsCompleteArgs = {
  userId: Scalars['UserID']['input'];
};


export type QueryProfilesArgs = {
  userIds: Array<Scalars['UserID']['input']>;
};


export type QuerySearchArgs = {
  input: SearchInput;
  page?: InputMaybe<PageInput>;
};


export type QueryStandaloneChallengeArgs = {
  challengeId: Scalars['UUID']['input'];
};


export type QueryStandaloneChallengeBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryStandaloneChallengeCategoryArgs = {
  category: Scalars['String']['input'];
  page?: InputMaybe<PageInput>;
};


export type QueryStandaloneEventArgs = {
  slug: Scalars['String']['input'];
};


export type QueryStandaloneSubmissionArgs = {
  submissionId: Scalars['UUID']['input'];
};


export type QueryStandaloneSubmissionsArgs = {
  challengeId?: InputMaybe<Scalars['UUID']['input']>;
  page?: InputMaybe<PageInput>;
};

export type SearchBlogFilterInput = {
  /** Only return blogs that match *all* given category names. */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SearchBlogFilterOptions = {
  __typename?: 'SearchBlogFilterOptions';
  /** List of ``categories`` values that match at least one blog. */
  categories: Array<Scalars['String']['output']>;
};

export type SearchChallengeFilterInput = {
  /** Only return challenges that match *all* given category names. */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Only return challenges that match any of the given difficulties. */
  difficulties?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SearchChallengeFilterOptions = {
  __typename?: 'SearchChallengeFilterOptions';
  /** List of ``categories`` values that match at least one challenge. */
  categories: Array<Scalars['String']['output']>;
  /** List of ``difficulty`` values that match at least one challenge. */
  difficulties: Array<Scalars['String']['output']>;
};

export type SearchCodebookFilterOptions = {
  __typename?: 'SearchCodebookFilterOptions';
  /** List of Codebook module categories that match at least one Codebook topic. */
  moduleCategories: Array<Scalars['String']['output']>;
  /** List of Codebook module titles that match at least one Codebook topic. */
  moduleTitles: Array<Scalars['String']['output']>;
};

export type SearchCodebookTopicFilterInput = {
  /** Only return Codebook topics in one of the given categories. */
  moduleCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Only return Codebook topics in one of the given modules. */
  moduleTitles?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SearchCompilationFilterInput = {
  /**
   * If ``True``, only return compilations that are *based on papers*.
   * If ``False``, do nothing.
   */
  basedOnPapers?: Scalars['Boolean']['input'];
  /** Only return compilations that match *all* given category names. */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SearchCompilationFilterOptions = {
  __typename?: 'SearchCompilationFilterOptions';
  /** List of Compilation categories that match at least one Compilation. */
  categories: Array<Scalars['String']['output']>;
};

export type SearchDatasetFamilyFilterInput = {
  /**
   * If ``True``, only return datasets that are *based on papers*.
   * If ``False``, do nothing.
   */
  basedOnPapers?: Scalars['Boolean']['input'];
  /** Only return dataset families in all the given categories. */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SearchDatasetsFilterOptions = {
  __typename?: 'SearchDatasetsFilterOptions';
  /** List of dataset family categories that match at least one dataset family. */
  categories: Array<Scalars['String']['output']>;
};

export type SearchDemoFilterInput = {
  /**
   * If ``True``, only return demos that are *based on papers*.
   * If ``False``, do nothing.
   */
  basedOnPapers?: Scalars['Boolean']['input'];
  /** Only return demos that match *all* given category names. */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SearchDemoFilterOptions = {
  __typename?: 'SearchDemoFilterOptions';
  /** List of ``categories`` values that match at least one demo. */
  categories: Array<Scalars['String']['output']>;
};

export type SearchDocFilterInput = {
  /** Only return docs in all the given projects. */
  projects?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Only return Docs with the given version. */
  version?: Scalars['String']['input'];
};

export type SearchDocFilterOptions = {
  __typename?: 'SearchDocFilterOptions';
  /** List of Read the Docs versions that match at least one PennyLane Doc. */
  projects: Array<Scalars['String']['output']>;
  /** List of Read the Docs versions that match at least one PennyLane Doc. */
  versions: Array<Scalars['String']['output']>;
};

export type SearchFilterOptions = {
  __typename?: 'SearchFilterOptions';
  blog: SearchBlogFilterOptions;
  challenge: SearchChallengeFilterOptions;
  codebook: SearchCodebookFilterOptions;
  compilation: SearchCompilationFilterOptions;
  datasets: SearchDatasetsFilterOptions;
  demo: SearchDemoFilterOptions;
  doc: SearchDocFilterOptions;
  profile: SearchProfileFilterOptions;
  /**
   * Returns relevant years of publication for the provided ``contentTypes``, or all
   * content if unspecified.
   */
  yearsOfPublication: Array<Scalars['Int']['output']>;
};


export type SearchFilterOptionsYearsOfPublicationArgs = {
  contentTypes?: InputMaybe<Array<ContentType>>;
};

export type SearchGenericFilterInput = {
  /** If set, only return results by the author with this handle. */
  authorHandle?: InputMaybe<Scalars['String']['input']>;
  /**
   * Years of publication to match. Results are matched using 'OR'.
   * ``None`` or ``[]`` implies no filtering.
   */
  yearsOfPublication?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type SearchInput = {
  /** A list of content types to filter by, or ``None`` for no filtering. */
  contentTypes?: InputMaybe<Array<ContentType>>;
  /** Content-generic filtering options, or ``None`` for no filtering. */
  genericFilters?: InputMaybe<SearchGenericFilterInput>;
  /** A search query. */
  query?: InputMaybe<Scalars['String']['input']>;
  sorts?: InputMaybe<Array<SearchSortableFieldSortInput>>;
  /** Content-specific filtering options, or ``None`` for no filtering. */
  specificFilters?: InputMaybe<SearchSpecificFilterInput>;
};

export type SearchProfileFilterInput = {
  /** Only return profiles that have at least one of the given types of social accounts. */
  socialAccountTypes?: InputMaybe<Array<ProfileSocialAccountType>>;
};

export type SearchProfileFilterOptions = {
  __typename?: 'SearchProfileFilterOptions';
  /** List of social account types that match at least one profile. */
  socialAccountTypes: Array<ProfileSocialAccountType>;
};

export enum SearchSortableField {
  PublishedAt = 'publishedAt',
  Title = 'title'
}

export type SearchSortableFieldSortInput = {
  desc?: Scalars['Boolean']['input'];
  field: SearchSortableField;
};

/**
 * Content-specific filtering options.
 *
 * At most one type of filtering may be applied, and it may only be provided if the
 * search query's ``contentType`` filter has one element, which matches the field.
 *
 * For example, ``demoFilters`` may only be set if
 * ``SearchInput.contentType == ["DEMO"]``.
 */
export type SearchSpecificFilterInput = {
  blogFilters?: InputMaybe<SearchBlogFilterInput>;
  challengeFilters?: InputMaybe<SearchChallengeFilterInput>;
  codebookTopicFilters?: InputMaybe<SearchCodebookTopicFilterInput>;
  compilationFilters?: InputMaybe<SearchCompilationFilterInput>;
  datasetFamilyFilters?: InputMaybe<SearchDatasetFamilyFilterInput>;
  demoFilters?: InputMaybe<SearchDemoFilterInput>;
  docFilters?: InputMaybe<SearchDocFilterInput>;
  profileFilters?: InputMaybe<SearchProfileFilterInput>;
};

export type SiteMapEntry = {
  __typename?: 'SiteMapEntry';
  lastModified: Scalars['DatetimeUTC']['output'];
  slug: Scalars['String']['output'];
};

export type StandaloneChallengeCategorySchema = {
  __typename?: 'StandaloneChallengeCategorySchema';
  category: Scalars['String']['output'];
  standaloneChallenges: StandaloneChallengeSchemaPaginationWindow;
};

export type StandaloneChallengeContent = Content & {
  __typename?: 'StandaloneChallengeContent';
  authors: Array<AuthorNameProfile>;
  categories?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  link: Scalars['String']['output'];
  modifiedAt: Scalars['DatetimeUTC']['output'];
  publishedAt: Scalars['DatetimeUTC']['output'];
  related: Array<Content>;
  slug: Scalars['String']['output'];
  standaloneChallenge: StandaloneChallengeSchema;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: ContentType;
};


export type StandaloneChallengeContentRelatedArgs = {
  contentTypes?: InputMaybe<Array<ContentType>>;
  count: Scalars['Int']['input'];
};

export enum StandaloneChallengeDifficulty {
  Advanced = 'ADVANCED',
  Beginner = 'BEGINNER',
  Intermediate = 'INTERMEDIATE'
}

export type StandaloneChallengeSchema = {
  __typename?: 'StandaloneChallengeSchema';
  /**
   * Detailed challenge information for the standalone challenge.
   *
   * Resolves to ``null`` if this standalone challenge is part of an event
   * that has not started yet.
   */
  challenge?: Maybe<ChallengeSchema>;
  /** Datetime when this standalone challenge was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Difficulty of the standalone challenge. */
  difficulty: StandaloneChallengeDifficulty;
  /** Standalone events associated with the standalone challenge. */
  events: Array<StandaloneEventSchema>;
  /** URL of the hero image for the standalone challenge. */
  heroImageUrl?: Maybe<Scalars['String']['output']>;
  /** URL of the icon for the standalone challenge. */
  iconUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Resolves to:
   *   * ``True`` if the user has a submission for the standalone challenge.
   *   * ``False`` if the user has no submissions for the standalone challenge.
   *   * ``None`` if the user is not authenticated.
   */
  isAttempted?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Resolves to:
   *   * ``True`` if the user has a passing submission for the standalone challenge.
   *   * ``False`` if the user has no passing submissions for the standalone challenge.
   *   * ``None`` if the user is not authenticated.
   */
  isCompleted?: Maybe<Scalars['Boolean']['output']>;
  /** Primary category of the standalone challenge. */
  primaryCategory: Scalars['String']['output'];
  /** Datetime when this standalone challenge was published. */
  publishedAt: Scalars['DateTime']['output'];
  /** Slug of the standalone challenge. */
  slug: Scalars['String']['output'];
  /** Summary of the standalone challenge. */
  summary: Scalars['String']['output'];
  /**
   * Category tags of the standalone challenge.
   *
   * It is guaranteed that at least one tag exists.
   *
   * The first tag is the primary category; all other tags are secondary categories.
   */
  tags: Array<Scalars['String']['output']>;
  /** Title of the standalone challenge. */
  title: Scalars['String']['output'];
  /** Datetime when this standalone challenge was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type StandaloneChallengeSchemaPaginationWindow = {
  __typename?: 'StandaloneChallengeSchemaPaginationWindow';
  items: Array<StandaloneChallengeSchema>;
  totalItems: Scalars['Int']['output'];
};

export type StandaloneEventBadgeProgressSchema = {
  __typename?: 'StandaloneEventBadgeProgressSchema';
  have: Scalars['Int']['output'];
  need: Scalars['Int']['output'];
};

export type StandaloneEventBadgeSchema = {
  __typename?: 'StandaloneEventBadgeSchema';
  /** Badge awarded to the user. */
  award?: Maybe<AwardedBadge>;
  /** Definition of the badge. */
  definition: BadgeDefinition;
  /** Progress the user has made towards this badge. */
  progress: StandaloneEventBadgeProgressSchema;
  /** Standalone challenges that must be completed to earn the badge. */
  standaloneChallenges: Array<StandaloneChallengeSchema>;
};

export type StandaloneEventBoardInput = {
  ascending?: Scalars['Boolean']['input'];
  badgeSlug?: InputMaybe<Scalars['String']['input']>;
};

export type StandaloneEventSchema = {
  __typename?: 'StandaloneEventSchema';
  /** Badges associated with the standalone event. */
  badges: Array<StandaloneEventBadgeSchema>;
  /** Badge board of the standalone event. */
  board: AwardedBadgePaginationWindow;
  /** Datetime when the standalone event is scheduled to finish. */
  finishAt: Scalars['DatetimeUTC']['output'];
  /** Slug of the standalone event. */
  slug: Scalars['String']['output'];
  /** Datetime when the standalone event is scheduled to start. */
  startAt: Scalars['DatetimeUTC']['output'];
  /** Status of the standalone event. */
  status: StandaloneEventStatus;
  /** Title of the standalone event. */
  title: Scalars['String']['output'];
};


export type StandaloneEventSchemaBoardArgs = {
  input?: InputMaybe<StandaloneEventBoardInput>;
  page?: InputMaybe<PageInput>;
};

export enum StandaloneEventStatus {
  Created = 'CREATED',
  Finished = 'FINISHED',
  Started = 'STARTED'
}

export type StandaloneSubmissionCreateInput = {
  challengeId: Scalars['UUID']['input'];
  submissionCode: Array<Scalars['String']['input']>;
};

export type StandaloneSubmissionResponse = {
  __typename?: 'StandaloneSubmissionResponse';
  standaloneSubmission?: Maybe<StandaloneSubmissionSchema>;
  userError?: Maybe<UserErrorSchema>;
};

export type StandaloneSubmissionSchema = {
  __typename?: 'StandaloneSubmissionSchema';
  /** ID of the standalone submission. */
  id: Scalars['UUID']['output'];
  /** Standalone challenge of the standalone submission. */
  standaloneChallenge: StandaloneChallengeSchema;
  /** Submission of the standalone submission. */
  submission: SubmissionSchema;
};

export type StandaloneSubmissionSchemaPaginationWindow = {
  __typename?: 'StandaloneSubmissionSchemaPaginationWindow';
  items: Array<StandaloneSubmissionSchema>;
  totalItems: Scalars['Int']['output'];
};

export type StrField = {
  value: Scalars['String']['input'];
};

export type StrOptionalField = {
  value?: InputMaybe<Scalars['String']['input']>;
};

export type StrPaginationWindow = {
  __typename?: 'StrPaginationWindow';
  items: Array<Scalars['String']['output']>;
  totalItems: Scalars['Int']['output'];
};

export type StrPayloadResponse = {
  __typename?: 'StrPayloadResponse';
  payload?: Maybe<Scalars['String']['output']>;
  userError?: Maybe<UserErrorSchema>;
};

export type SubmissionResultSchema = {
  __typename?: 'SubmissionResultSchema';
  /** Detail of the submission result. */
  detail?: Maybe<Scalars['String']['output']>;
  /** Solution output of the submission result. */
  solutionOutput?: Maybe<Scalars['String']['output']>;
  /** Standard output of the submission result. */
  standardOutput?: Maybe<Scalars['String']['output']>;
  /** Status of the submission result. */
  status: SubmissionResultStatus;
  /** Test case of the submission result. */
  testCase: TestCaseSchema;
};

export enum SubmissionResultStatus {
  Correct = 'CORRECT',
  Created = 'CREATED',
  InternalError = 'INTERNAL_ERROR',
  MemoryLimitExceeded = 'MEMORY_LIMIT_EXCEEDED',
  Running = 'RUNNING',
  RuntimeError = 'RUNTIME_ERROR',
  TimeLimitExceeded = 'TIME_LIMIT_EXCEEDED',
  WrongAnswer = 'WRONG_ANSWER'
}

export type SubmissionSchema = {
  __typename?: 'SubmissionSchema';
  /**
   * Gets the code blocks for this submission.
   * Includes the challenge's public code blocks, and the submission code in place
   * of the ``SOLUTION_TEMPLATE`` blocks.
   */
  codeBlocks: Array<CodeBlockSchema>;
  /** ID of the submission. */
  id: Scalars['UUID']['output'];
  /** Private results status of the submission. */
  privateResultsStatus?: Maybe<SubmissionStatus>;
  /** Public results status of the submission. */
  publicResultsStatus?: Maybe<SubmissionResultStatus>;
  /** Results of the submission. */
  results: Array<SubmissionResultSchema>;
  /** Status of the submission. */
  status: SubmissionStatus;
  /** Datetime when the submission was made. */
  submittedAt: Scalars['DateTime']['output'];
};

export enum SubmissionStatus {
  Created = 'CREATED',
  Failed = 'FAILED',
  Passed = 'PASSED',
  Running = 'RUNNING'
}

export type TableOfContentsEntry = {
  __typename?: 'TableOfContentsEntry';
  children: Array<BaseTableOfContentsEntry>;
  href: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type TeamMemberSchema = {
  __typename?: 'TeamMemberSchema';
  /** Whether the team member was deleted. */
  deleted: Scalars['Boolean']['output'];
  /** Whether the team member is the team contact. */
  isContact: Scalars['Boolean']['output'];
  /** Datetime when the team member joined the team. */
  joinedAt: Scalars['DateTime']['output'];
  /** Player ID of the team member. */
  playerId: Scalars['UUID']['output'];
  /** Profile of the team member. */
  profile: Profile;
};

export type TeamResponse = {
  __typename?: 'TeamResponse';
  team?: Maybe<TeamSchema>;
  userError?: Maybe<UserErrorSchema>;
};

export type TeamSchema = {
  __typename?: 'TeamSchema';
  /**
   * Returns the team's most recent project submission.
   *
   * Returns:
   *     None: If the caller does not have permission to view this team's project
   *       submission.
   *
   *     None: If the team does not have an active project submission.
   */
  activeProjectSubmission?: Maybe<ProjectSubmissionSchema>;
  /** Event submissions of the team. */
  eventSubmissions?: Maybe<Array<EventSubmissionSchema>>;
  /** ID of the team. */
  id: Scalars['UUID']['output'];
  /** Whether the team is locked. */
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  /** Join code of the team. */
  joinCode?: Maybe<Scalars['String']['output']>;
  /** Members of the team. */
  members: Array<TeamMemberSchema>;
  /** Name of the team. */
  name: Scalars['String']['output'];
  /** Event challenges that the team has completed. */
  solvedEventChallenges?: Maybe<Array<EventChallengeSchema>>;
};

export type TeamSchemaPaginationWindow = {
  __typename?: 'TeamSchemaPaginationWindow';
  items: Array<TeamSchema>;
  totalItems: Scalars['Int']['output'];
};

export type TestCaseSchema = {
  __typename?: 'TestCaseSchema';
  /** Expected output of the test case. */
  expectedOutput?: Maybe<Scalars['String']['output']>;
  /** ID of the test case. */
  id: Scalars['UUID']['output'];
  /** Input of the test case. */
  input?: Maybe<Scalars['String']['output']>;
  /** Whether the test case is public. */
  public: Scalars['Boolean']['output'];
};

export type UpdateCertificateRecipientInfoResponse = {
  __typename?: 'UpdateCertificateRecipientInfoResponse';
  email: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
};

export type UpdateCertificateRecipientInfoResponsePayloadResponse = {
  __typename?: 'UpdateCertificateRecipientInfoResponsePayloadResponse';
  payload?: Maybe<UpdateCertificateRecipientInfoResponse>;
  userError?: Maybe<UserErrorSchema>;
};

export type UserErrorSchema = {
  __typename?: 'UserErrorSchema';
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type SearchContentQueryVariables = Exact<{
  input: SearchInput;
  page?: InputMaybe<PageInput>;
}>;


export type SearchContentQuery = { __typename?: 'Query', search: { __typename?: 'AnyContentPaginationWindow', totalItems: number, items: Array<{ __typename?: 'GenericContent', id: string, type: ContentType, title: string, description?: string | null, slug: string, link: string } | { __typename?: 'ProfileContent', id: string, type: ContentType, title: string, description?: string | null, slug: string, link: string, profile: { __typename?: 'Profile', handle: string } } | { __typename?: 'StandaloneChallengeContent', id: string, type: ContentType, title: string, description?: string | null, slug: string, link: string }> } };



export const SearchContentDocument = `
    query SearchContent($input: SearchInput!, $page: PageInput) {
  search(input: $input, page: $page) {
    items {
      ... on Content {
        id
        type
        title
        description
        slug
        link
      }
      ... on ProfileContent {
        profile {
          handle
        }
      }
    }
    totalItems
  }
}
    `;

export const useSearchContentQuery = <
      TData = SearchContentQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: SearchContentQueryVariables,
      options?: Omit<UseQueryOptions<SearchContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SearchContentQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<SearchContentQuery, TError, TData>(
      {
    queryKey: ['SearchContent', variables],
    queryFn: fetcher<SearchContentQuery, SearchContentQueryVariables>(client, SearchContentDocument, variables, headers),
    ...options
  }
    )};

export const useInfiniteSearchContentQuery = <
      TData = InfiniteData<SearchContentQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: SearchContentQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SearchContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SearchContentQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<SearchContentQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['SearchContent.infinite', variables],
      queryFn: (metaData) => fetcher<SearchContentQuery, SearchContentQueryVariables>(client, SearchContentDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};
